export enum CURVE_TYPES {
  DOOR_CURVE = 'doorCurve',
  SIZE_CURVE = 'sizeCurve'
}

const isSizeOptionDisabled = (hasSizes): boolean => {
  return !hasSizes
}

const showCurrentSizeOperation = (captureSize): boolean => {
  return !!captureSize
}

export const ROLLUP_OPERATIONS_IDS = {
  SIZES_TO_DOORS_AND_PRODUCT: 'SIZES_TO_DOORS_AND_PRODUCT',
  SIZES_TO_DOORS: 'SIZES_TO_DOORS',
  DOORS_TO_PRODUCT: 'DOORS_TO_PRODUCT'
}

export const SPLIT_OPERATIONS_IDS = {
  PRODUCTS_TO_DOORS_SIZES: 'PRODUCTS_TO_DOORS_SIZES',
  PRODUCTS_TO_DOORS: 'PRODUCTS_TO_DOORS',
  DOORS_TO_SIZES: 'DOORS_TO_SIZES'
}

export const SPLIT_OPERATIONS_LIST = [
  {
    id: SPLIT_OPERATIONS_IDS.PRODUCTS_TO_DOORS_SIZES,
    label: 'Products to Doors, Sizes',
    key: 'order.productsToDoorsSizes',
    showCurrentOperation: showCurrentSizeOperation,
    isOptionDisabled: isSizeOptionDisabled
  },
  {
    id: SPLIT_OPERATIONS_IDS.PRODUCTS_TO_DOORS,
    label: 'Products to Doors',
    key: 'order.ProductsToDoors',
    showCurrentOperation: () => true,
    isOptionDisabled: () => false
  },
  {
    id: SPLIT_OPERATIONS_IDS.DOORS_TO_SIZES,
    label: 'Doors to Sizes',
    key: 'order.doorsToSizes',
    showCurrentOperation: showCurrentSizeOperation,
    isOptionDisabled: isSizeOptionDisabled
  }
]

export const ROLL_UP_OPERATIONS_LIST = [
  {
    id: ROLLUP_OPERATIONS_IDS.SIZES_TO_DOORS_AND_PRODUCT,
    label: 'Sizes to Doors, Product',
    key: 'order.sizesToDoorsProduct',
    showCurrentOperation: showCurrentSizeOperation,
    isOptionDisabled: isSizeOptionDisabled
  },
  {
    id: ROLLUP_OPERATIONS_IDS.SIZES_TO_DOORS,
    label: 'Sizes to Doors',
    key: 'order.sizesToDoors',
    showCurrentOperation: showCurrentSizeOperation,
    isOptionDisabled: isSizeOptionDisabled
  },
  {
    id: ROLLUP_OPERATIONS_IDS.DOORS_TO_PRODUCT,
    label: 'Doors to Products',
    key: 'order.doorsToProducts',
    showCurrentOperation: () => true,
    isOptionDisabled: () => false
  }
]
